export enum SyncDataType {
    Freshline = 1,
}

export const enumLabel = (value?: SyncDataType) => {
    switch (value) {
        case SyncDataType.Freshline:
            return 'Freshline';
        default:
            return '';
    }
};